import { APP_CONFIG } from 'src/config/app.config';

function getApiBaseUrl(): string {
  const hostname = window.location.hostname;
  const key = Object.keys(APP_CONFIG).find(item => hostname.includes(item)) || 'dev';
  const apiUrl = APP_CONFIG[key as keyof typeof APP_CONFIG].find(item =>
    hostname.includes(item.WEB_URL),
  )?.API_BASE_URL;

  if (!apiUrl) throw new Error(`No API URL configured for host: ${hostname}`);
  return apiUrl;
}

const API_BASE_URL = getApiBaseUrl();

export { API_BASE_URL };
export const IS_DEV_ENV = API_BASE_URL.includes('dev') || API_BASE_URL.includes('local');
export const IS_QA_ENV = API_BASE_URL.includes('qa');
export const IS_PROD_ENV = !IS_QA_ENV && !IS_DEV_ENV;
